<template>
  <b-input
    :value="typeformUrl"
    v-bind="$attrs"
    expanded
    icon="link"
    placeholder="Typeform Url"
    type="text"
    required
    validation-message="Only valid madamcurious typeform links are allowed"
    :pattern="TYPEFORM_URL_REGEX"
    @input="inputHandler"
  >
  </b-input>
</template>

<script>
export default {
  data() {
    return {
      TYPEFORM_URL_REGEX:
        '^https:\\/\\/madamcurious\\.typeform\\.com\\/to\\/(\\w{6})$'
    };
  },
  props: {
    value: {
      type: String,
      default: ''
    }
  },
  computed: {
    typeformUrl() {
      if (this.value) {
        return `https://madamcurious.typeform.com/to/${this.value}`;
      } else return '';
    }
  },
  methods: {
    inputHandler(url) {
      const match = url.match(new RegExp(this.TYPEFORM_URL_REGEX));
      if (match) this.$emit('input', match[1]);
      else this.$emit('input', null);
    }
  }
};
</script>

<style></style>
